// @ts-check
/**
 * Generated user context to help Launch Darkly identify the user
 * @param {Object} account User account
 * @returns {import('launchdarkly-js-sdk-common').LDContext} context
 */
export function getLDContext(account = {}) {
  const {
    current_provider_organization_id: organizationId,
    organizations = []
  } = account;
  const { provider_organization_name: organizationName } = organizations.find(
    org => org.provider_organization_id === organizationId
  );

  /**
   * @type {import('launchdarkly-js-sdk-common').LDContext}
   */
  const context = {
    kind: 'organization',
    key: organizationName,
    orgId: organizationId
  };

  return context;
}
